// extracted by mini-css-extract-plugin
export default {"filterGrid":"workspace-filter_filterGrid__ah+Js"};